export default __webpack_public_path__ + "static/char-07-2efb6eb15cc5c6cb8bb4022975a377cb.gif";